/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Carrier_EditInputs */

const vi_shipping_carrier_edit = /** @type {(inputs: Shipping_Carrier_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa đơn vị`)
};

/**

* @param {Shipping_Carrier_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier_edit = /** @type {((inputs?: Shipping_Carrier_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Carrier_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier_edit(inputs)
});